import { configureStore } from '@reduxjs/toolkit';

import { config } from '_config';

import amendmentSlice from './amendment/slice';
import bankAccountsSlice from './bankAccounts/slice';
import billingSlice from './billing/slice';
import chatSlice from './chat/slice';
import credentialsSlice from './credentials/slice';
import currentTransactionSlice from './currentTransaction/slice';
import fileTypesSlice from './fileTypes/slice';
import filesSlice from './files/slice';
import meetingsSlice from './meetings/slice';
import messagesSlice from './messages/slice';
import { authorizationCheckMiddleware, notificationSystemMiddleware } from './middlewares';
import modalsSlice from './modals/slice';
import oauthSlice from './oauth/slice';
import orderSlice from './order/slice';
import ordersSlice from './orders/slice';
import reportsSlice from './reports/slice';
import statementsSlice from './statements/slice';
import tasksSlice from './tasks/slice';
import taxFilingInfoSlice from './taxFilingInfo/slice';
import transactionCategoriesSlice from './transactionCategories/slice';
import upcomingDatesSlice from './upcomingDates/slice';
import userSlice from './user/slice';
import variantsSlice from './variants/slice';

export default configureStore({
  reducer: {
    oauth: oauthSlice,
    user: userSlice,
    credentials: credentialsSlice,
    order: orderSlice,
    orders: ordersSlice,
    messages: messagesSlice,
    reports: reportsSlice,
    bankAccounts: bankAccountsSlice,
    billing: billingSlice,
    currentTransaction: currentTransactionSlice,
    transactionCategories: transactionCategoriesSlice,
    files: filesSlice,
    fileTypes: fileTypesSlice,
    statements: statementsSlice,
    tasks: tasksSlice,
    upcomingDates: upcomingDatesSlice,
    modals: modalsSlice,
    taxFilingInfo: taxFilingInfoSlice,
    variants: variantsSlice,
    amendment: amendmentSlice,
    chat: chatSlice,
    meetings: meetingsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      authorizationCheckMiddleware,
      notificationSystemMiddleware,
    ]),
  devTools: config.devtools === 'true',
});
